import { Logger } from '../model/device/logger.model';
import { LoggerStrategies } from '../constants/logger';
import { GoogleLoggerStrategy } from './google-logger.service';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';

export class LoggerManagerService implements Logger {
  private readonly logger: Logger;
  constructor(
    private readonly analyticsService: AngularFireAnalytics,
    private readonly strategy: LoggerStrategies = LoggerStrategies.GOOGLE
  ) {
    const dictStrategys: { [key: string]: Logger } = {
      GoogleStrategy: new GoogleLoggerStrategy(this.analyticsService),
    };
    this.logger = dictStrategys[this.strategy];
  }

  exception(exception: any, isFatal: boolean): void {
    this.logger.exception(exception.message, isFatal);
  }
  event(name: string): void {
    this.logger.event(name);
  }
}
